import {Component, Vue} from 'vue-property-decorator'
import { getMaxLimitDate, getMinLimitDate} from "../common/dateTimeHelper";

@Component
class DateLimitsMixin extends Vue {
    get offset() {
        return this.$store.state.timeZoneOffset;
    }

    get minLimit() {
        const date = this.$store.getters['events/selectedEvent']?.beginAt;
        return getMinLimitDate(date, this.offset);
    }

    get maxLimit() {
        const date = this.$store.getters['events/selectedEvent']?.endAt;
        return getMaxLimitDate(date, this.offset);
    }
}

export default DateLimitsMixin